import "./App.css";
import Home from "./components/Home/Home";
import { Routes, Route } from "react-router-dom";
import RunMyTransport from "./components/Products/RunMyTransport";
import Reward from "./components/Products/Reward";
import Careers from "./components/Careers/Careers";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/runmytransport" element={<RunMyTransport />} />
      <Route path="/reward" element={<Reward />} />

      <Route path="/careers" element={<Careers />} />
    </Routes>
  );
}

export default App;
